import React from 'react';

import { useDossierValidationHeader, useSearchBar } from '@europrocurement/l2d-modules';
import { GenericSearchBar } from '@europrocurement/l2d-modules/modules/Societes/components';
import { useParcoursFormalitreHeader } from '@europrocurement/l2d-modules/modules/ParcoursFormalite/provider';
import { Box, Container } from '@mui/system';
import { Stepper } from '@europrocurement/flexy-components';
import { DossierDocumentsValidationCustomHeader } from '../pages/Dossiers/components';

const B2DCustomHeader: React.FunctionComponent = function () {
    const { isSearchBarPath } = useSearchBar();
    const { isParcoursPath, steps } = useParcoursFormalitreHeader();
    const { isDossierValidationPath } = useDossierValidationHeader();

    if (isSearchBarPath) {
        return <GenericSearchBar />;
    }

    if (isParcoursPath) {
        return (
            <Box sx={{ width: '100%', padding: 'auto' }}>
                <Container maxWidth="md">
                    <Stepper steps={steps} />
                </Container>
            </Box>
        );
    }

    if (isDossierValidationPath) {
        return <DossierDocumentsValidationCustomHeader />;
    }

    return null;
};

export default B2DCustomHeader;
